import { useCallback } from 'react'

import { useUnit } from 'effector-react'
import { useIntercom } from 'react-use-intercom'

import { $account } from '@/models/account.ts'

export function useRequestReferral() {
  const intercom = useIntercom()
  const account = useUnit($account)

  return useCallback(
    (link: string) => {
      const content = `Hi, I would like to request to request the referral link ${link}`

      intercom.showNewMessage(content)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [account?.email, intercom],
  )
}
